import "./Specs.css";
import { memo } from "react";

const Specs = ({ Icon, text }) => {
  return (
    <div className="specs">
      {Icon && <Icon className="specs__icon" />}
      <p>{text}</p>
    </div>
  );
};

export default memo(Specs);
